import { AxiosService } from './axios.service'
import { SearchService } from './search.service'
import {
	paginationSuccessHandler,
	paginationErrorHandler
} from './pagination-handlers'
import { PAYMENT_METHODS } from '@constants'

/**
 * Defines the API methods for a coupon
 */
export class CouponService extends SearchService {
	static baseURL = 'cupom-de-desconto'

	/**
	 * Searches the coupons
	 * @return {Promise<any[]>} List of coupons
	 */
	static search(params) {
		return AxiosService.get(`${CouponService.baseURL}/buscar`, { params })
			.then(paginationSuccessHandler)
			.catch(paginationErrorHandler)
	}

	/**
	 * Activates a coupon
	 * @param {number} couponId The couponId to be activate
	 */
	static activate(couponId) {
		return AxiosService.post(
			`${CouponService.baseURL}/${couponId}/ativar`
		).then(({ data }) => data)
	}

	/**
	 * Inactivates a coupon
	 * @param {number} couponId The couponId to be inactivate
	 */
	static inactivate(couponId) {
		return AxiosService.post(
			`${CouponService.baseURL}/${couponId}/inativar`
		).then(({ data }) => data)
	}

	/**
	 * Creates a coupon
	 * @param {object} params The data to create the
	 */
	static create(params) {
		if (params.couponsAmount < 1) params.couponsAmount = -1
		if (params.daysInAdvanceForBoarding === '') {
			params.daysInAdvanceForBoarding = null
		} else if (
			params.daysInAdvanceForBoarding !== null &&
			params.daysInAdvanceForBoarding !== 'null' &&
			!isNaN(params.daysInAdvanceForBoarding)
		) {
			// Converte string numérica para número
			params.daysInAdvanceForBoarding = parseInt(
				params.daysInAdvanceForBoarding,
				10
			)
		}

		params.discountPercentage = parseInt(params.discountPercentage, 10)
		params.code = params.code.toUpperCase()
		return AxiosService.put(CouponService.baseURL, params).then(
			({ data }) => data
		)
	}

	/**
	 * Get a coupon details
	 * @param {number} params The coupon identifier
	 */
	static getDetails(couponId) {
		return AxiosService.get(`${CouponService.baseURL}/${couponId}`).then(
			({ data }) => {
				const { couponsAmount } = data.data
				data.data.couponsAmount =
					couponsAmount == -1 ? undefined : couponsAmount
				return data
			}
		)
	}

	/**
	 * Update a coupon
	 * @param {number} params The coupon identifier
	 */
	static update(couponId, params) {
		if (params.boardingDate === 'null') params.boardingDate = ''
		if (params.boardingDateEnd === 'null') params.boardingDateEnd = ''
		if (params.couponsAmount === '') params.couponsAmount = -1
		if (params.daysInAdvanceForBoarding === '') {
			params.daysInAdvanceForBoarding = null
		} else if (
			params.daysInAdvanceForBoarding !== null &&
			params.daysInAdvanceForBoarding !== 'null' &&
			!isNaN(params.daysInAdvanceForBoarding)
		) {
			// Converte string numérica para número
			params.daysInAdvanceForBoarding = parseInt(
				params.daysInAdvanceForBoarding,
				10
			)
		}
		params.code = params.code.toUpperCase()
		return AxiosService.post(
			`${CouponService.baseURL}/${couponId}`,
			params
		).then(({ data }) => data)
	}

	/**
	 * Find a coupon
	 * @param {string} code The coupon code
	 */
	static find(
		code,
		cpf,
		type,
		points,
		busCompany,
		boardingDate,
		hasReturn,
		busClass,
		paymentMethod,
		origin,
		destination,
		routesGoing,
		routesReturn
	) {
		const params = {
			code,
			cpf,
			type,
			points,
			busCompany,
			boardingDate,
			hasReturn,
			busClass,
			paymentMethod,
			origin,
			destination,
			routesGoing,
			routesReturn
		}

		if (params.code) params.code = params.code.toUpperCase()

		return AxiosService.post(
			`${CouponService.baseURL}/encontrar/`,
			params
		).then(({ data }) => data)
	}

	/**
	 * Calculate the total value using the given coupon
	 * @param {number} value The value
	 * @param {number} discountPercentage The discount percentage
	 * @returns {number} The total value applying the given coupon
	 */
	static applyDiscount(value, discountPercentage) {
		const multiplier = (100 - discountPercentage) / 100
		return value * multiplier
	}

	/**
	 * Find a promotion coupon
	 * @param {string} code The coupon code
	 */
	static findPromotionAutomaticallyCoupon(
		busCompany,
		boardingDate,
		hasReturn,
		busClass,
		paymentMethod,
		origin,
		destination,
		routesGoing,
		routesReturn
	) {
		const params = {
			busCompany,
			boardingDate,
			hasReturn,
			busClass,
			paymentMethod,
			origin,
			destination,
			routesGoing,
			routesReturn
		}

		if (params.code) params.code = params.code.toUpperCase()

		return AxiosService.post(
			`${CouponService.baseURL}/buscar-cupom-promocional-automatico/`,
			params
		).then(({ data }) => data)
	}
}
